export enum RateLimiterScopes {
	Flow,
	Project,
	Client,
}
